/* ==========================================================================
   PROTÉGEZ VOS PROCHES — achat, panier, consentement, Meta Pixel
   Aucune dépendance. Chargé en defer.
   ========================================================================== */
(function () {
  "use strict";

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  var MAX_QTY = 1;                 // un seul exemplaire par commande
  var busy = false;                // verrou global anti-double-clic
  var CONSENT_KEY = "svp_consent_v1";

  function j(url, opts) {
    return fetch(url, Object.assign({
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      credentials: "same-origin"
    }, opts || {})).then(function (r) {
      if (!r.ok) return r.text().then(function (t) { throw new Error(t || r.status); });
      return r.json();
    });
  }

  /* ====================================================================
     1. NORMALISATION DU PANIER — jamais plus de 1 exemplaire
     Corrige aussi les paniers hérités contenant 2, 3, 4 exemplaires.
     ==================================================================== */
  function normalizeCart() {
    return j(ROOT + "cart.js").then(function (cart) {
      var fixes = [];
      (cart.items || []).forEach(function (item, i) {
        if (item.quantity > MAX_QTY) {
          fixes.push({ line: i + 1, quantity: MAX_QTY });
        }
      });
      if (!fixes.length) { normalizeCart.changed = false; return cart; }
      normalizeCart.changed = true;
      // applique les corrections en série (Shopify recalcule les index à chaque appel)
      return fixes.reduce(function (chain, fix) {
        return chain.then(function () {
          return j(ROOT + "cart/change.js", {
            method: "POST",
            body: JSON.stringify({ line: fix.line, quantity: fix.quantity })
          });
        });
      }, Promise.resolve()).then(function () { return j(ROOT + "cart.js"); });
    }).catch(function () { return null; });
  }

  function cartHasVariant(cart, variantId) {
    if (!cart || !cart.items) return false;
    return cart.items.some(function (it) { return String(it.variant_id) === String(variantId); });
  }

  /* ====================================================================
     2. BOUTON D'ACHAT — anti-double-clic, état de chargement
     ==================================================================== */
  function setLoading(btn, on) {
    if (!btn) return;
    if (on) {
      btn.dataset.prevHtml = btn.innerHTML;
      btn.innerHTML = btn.dataset.labelLoading || "Chargement…";
      btn.disabled = true;
      btn.setAttribute("aria-busy", "true");
      btn.style.pointerEvents = "none";
      btn.style.opacity = "0.72";
    } else {
      if (btn.dataset.prevHtml) btn.innerHTML = btn.dataset.prevHtml;
      btn.disabled = false;
      btn.removeAttribute("aria-busy");
      btn.style.pointerEvents = "";
      btn.style.opacity = "";
    }
  }

  function showError(form, msg) {
    var el = form.querySelector("[data-buy-error]");
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
  }
  function clearError(form) {
    var el = form.querySelector("[data-buy-error]");
    if (el) { el.hidden = true; el.textContent = ""; }
  }

  document.querySelectorAll("[data-buy-form]").forEach(function (form) {
    var btn = form.querySelector("[data-buy-btn]");
    var variantId = form.getAttribute("data-variant-id");
    var mode = form.getAttribute("data-buy-mode") || "checkout";

    form.addEventListener("submit", function (e) {
      e.preventDefault();

      /* Verrou : tout clic supplémentaire pendant le traitement est ignoré,
         quel que soit le bouton de la page (ils partagent le même verrou). */
      if (busy) return;
      busy = true;
      clearError(form);
      setLoading(btn, true);

      // Meta Pixel : début de paiement (uniquement si consenti)
      window.SVPTrack && window.SVPTrack("InitiateCheckout", {
        content_type: "product",
        content_ids: [variantId],
        value: window.SVP_PRICE || undefined,
        currency: "CAD"
      });

      /* Boutique mono-produit : on VIDE le panier puis on ajoute exactement 1.
         Plus fiable que « ajouter puis corriger » — le panier ne peut pas
         s'accumuler d'une session à l'autre, ni si un ajout se répète. */
      j(ROOT + "cart/clear.js", { method: "POST" })
        .then(function () {
          return j(ROOT + "cart/add.js", {
            method: "POST",
            body: JSON.stringify({ items: [{ id: Number(variantId), quantity: MAX_QTY }] })
          });
        })
        .then(function () {
          if (mode === "cart") {
            window.location.href = ROOT + "cart";
          } else {
            window.location.href = ROOT + "checkout";
          }
          // on laisse `busy` à true : la page navigue
        })
        .catch(function () {
          busy = false;
          setLoading(btn, false);
          showError(form, "Le paiement n'a pas pu démarrer. Veuillez réessayer.");
        });
    });
  });

  /* Au chargement de toute page : on assainit un éventuel panier hérité.
     Sur la page PANIER, le HTML est rendu par le serveur : corriger le panier
     en arrière-plan ne suffit pas, l'ancien total resterait affiché.
     On recharge donc une seule fois — le garde-fou empêche toute boucle. */
  if (document.querySelector("[data-buy-form], [data-cart-page]")) {
    normalizeCart().then(function () {
      var FLAG = "svp_cart_fixed_once";
      if (!normalizeCart.changed) {
        // panier sain : on réarme le garde-fou pour la prochaine fois
        try { sessionStorage.removeItem(FLAG); } catch (e) {}
        return;
      }
      if (!document.querySelector("[data-cart-page]")) return;
      try {
        if (sessionStorage.getItem(FLAG)) return;   // déjà rechargé : on n'insiste pas
        sessionStorage.setItem(FLAG, "1");
      } catch (e) { return; }                       // stockage indisponible : pas de rechargement
      window.location.reload();
    });
  }

  /* ====================================================================
     3. PAGE PANIER — retirer, vider, quantité verrouillée
     ==================================================================== */
  var cartPage = document.querySelector("[data-cart-page]");
  if (cartPage) {
    cartPage.addEventListener("click", function (e) {
      var rm = e.target.closest("[data-cart-remove]");
      var clr = e.target.closest("[data-cart-clear]");
      if (!rm && !clr) return;
      e.preventDefault();
      if (busy) return;
      busy = true;
      var req = clr
        ? j(ROOT + "cart/clear.js", { method: "POST" })
        : j(ROOT + "cart/change.js", {
            method: "POST",
            body: JSON.stringify({ line: Number(rm.getAttribute("data-cart-remove")), quantity: 0 })
          });
      req.then(function () { window.location.reload(); })
         .catch(function () { busy = false; });
    });
  }

  /* ====================================================================
     4. CONSENTEMENT AUX TÉMOINS
     ==================================================================== */
  function readConsent() {
    try { return JSON.parse(localStorage.getItem(CONSENT_KEY) || "null"); }
    catch (e) { return null; }
  }
  function saveConsent(c) {
    c.date = new Date().toISOString();
    try { localStorage.setItem(CONSENT_KEY, JSON.stringify(c)); } catch (e) {}
    applyConsent(c);
  }
  window.SVPConsent = { read: readConsent };

  function applyConsent(c) {
    // API de consentement Shopify (respecte aussi les réglages de la boutique)
    if (window.Shopify && window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.setTrackingConsent) {
      try {
        window.Shopify.customerPrivacy.setTrackingConsent({
          analytics: !!c.analytics,
          marketing: !!c.marketing,
          preferences: !!c.analytics
        }, function () {});
      } catch (e) {}
    }
    if (c.marketing) loadPixel();
  }

  /* ---- Meta Pixel : chargé UNIQUEMENT après consentement publicitaire ---- */
  var pixelLoaded = false;
  function loadPixel() {
    if (pixelLoaded) return;
    var id = window.SVP_PIXEL_ID;
    if (!id) return;                     // aucun identifiant configuré → rien ne se charge
    pixelLoaded = true;

    /* eslint-disable */
    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
    n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}
    (window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */

    fbq("init", id);
    fbq("track", "PageView");

    if (document.body.getAttribute("data-template") === "index") {
      fbq("track", "ViewContent", {
        content_type: "product",
        content_name: "Protégez vos proches — Le Guide Familial Anti-Arnaque",
        value: window.SVP_PRICE || undefined,
        currency: "CAD"
      });
    }
    // rejoue les évènements mis en file avant le consentement
    (window.__svpQueue || []).forEach(function (a) { fbq("track", a[0], a[1]); });
    window.__svpQueue = [];
  }

  /* File d'attente : si l'utilisateur n'a pas encore consenti, on mémorise sans envoyer. */
  window.__svpQueue = [];
  window.SVPTrack = function (name, params) {
    var c = readConsent();
    if (c && c.marketing && window.fbq) { window.fbq("track", name, params); }
    else if (!c || !c.marketing) { window.__svpQueue.push([name, params]); }
  };

  /* ---- Bandeau ---- */
  var banner = document.getElementById("svp-cookie");
  var panel  = document.getElementById("svp-cookie-prefs");

  function openBanner()  { if (banner) banner.hidden = false; }
  function closeBanner() { if (banner) banner.hidden = true; }
  function openPanel()   { if (panel) { panel.hidden = false; document.body.style.overflow = "hidden"; } }
  function closePanel()  { if (panel) { panel.hidden = true; document.body.style.overflow = ""; } }

  if (banner || panel) {
    var existing = readConsent();
    if (existing) applyConsent(existing);
    else if (banner && banner.getAttribute("data-enabled") === "true") openBanner();

    document.addEventListener("click", function (e) {
      var t = e.target;
      if (!t || typeof t.closest !== "function") return;   // garde-fou
      if (t.closest("[data-cc-accept]")) {
        saveConsent({ essential: true, analytics: true, marketing: true });
        closeBanner(); closePanel();
      }
      if (t.closest("[data-cc-reject]")) {
        saveConsent({ essential: true, analytics: false, marketing: false });
        closeBanner(); closePanel();
      }
      if (t.closest("[data-cc-customize]")) { openPanel(); }
      if (t.closest("[data-cc-close]")) { closePanel(); }
      if (t.closest("[data-cc-save]")) {
        var a = document.getElementById("cc-analytics");
        var m = document.getElementById("cc-marketing");
        saveConsent({ essential: true, analytics: !!(a && a.checked), marketing: !!(m && m.checked) });
        closeBanner(); closePanel();
      }
      if (t.closest("[data-cc-open]")) {          // « Gérer mes témoins » (footer)
        e.preventDefault();
        var cur = readConsent() || { analytics: false, marketing: false };
        var a2 = document.getElementById("cc-analytics");
        var m2 = document.getElementById("cc-marketing");
        if (a2) a2.checked = !!cur.analytics;
        if (m2) m2.checked = !!cur.marketing;
        openPanel();
      }
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && panel && !panel.hidden) closePanel();
    });
  }
})();
